export default {"src":"/_next/static/media/circle-check-regular.7313be11.svg","height":24,"width":24};